export interface IAsset {
    name: string;
    path: string;
    type: string;
    public: boolean;
}
